import * as React from 'react';
import { AppBar, IconButton, MenuItem, Toolbar, Typography, Menu, Tooltip, Avatar, Divider, Stack } from "@mui/material";

import MenuIcon from '@mui/icons-material/Menu';
import { useAuthDispatch, useAuthState } from "../../context/authContext";
import { Link } from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
interface AppBarProps {
  drawerWidth: number,
  handleDrawerToggle: any,
}

const Navigation = ({ handleDrawerToggle, drawerWidth }: AppBarProps) => {

  const user = useAuthState();
  const autDispatch = useAuthDispatch();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const logout = () => {
    handleClose()
    autDispatch({
      type: "logout"
    })

  }

  return (

    <AppBar position="fixed"
      sx={{
        width: { sm: `calc(100% - 230px)` }, height: '75px',
        ml: { sm: `230px` }, backgroundColor: '#001933', boxShadow: 'none', borderEndEndRadius: 10, borderEndStartRadius: 10,
      }}>
      <Toolbar>
        <IconButton
          aria-label="open drawer"
          edge="start"
          onClick={handleDrawerToggle}
          sx={{ mr: 2, ml: 1, display: { sm: 'none' }, color: '#E80000' }}
        >
          <MenuIcon />
        </IconButton>
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Sistema de Gestión de Contenido
        </Typography>
        <div>
          <Tooltip title="Más opciones" arrow>
            <IconButton onClick={handleMenu} sx={{ p: 0 }} className='moreoptions'>
              <Avatar alt={user.nombre} src={"imageProfile"} />
            </IconButton>
          </Tooltip>
          {/* <IconButton
            size="large"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            onClick={handleMenu}
            color="inherit"
          >
            <AccountCircle />
          </IconButton> */}
          <Menu
             sx={{ mt: '52px' }}
             id="menu-appbar"
             anchorEl={anchorEl}
             anchorOrigin={{ vertical: 'top', horizontal: 'right', }}
             keepMounted
             transformOrigin={{ vertical: 'top', horizontal: 'right', }}
             open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem sx={{ paddingRight: 10 }} key="user-info" /* onClick={handleCount} */ >
              <Stack>
                <Typography sx={{ fontStyle: 'italic', fontWeight: 'bold' }} textAlign="left">{`${user.nombre}`}</Typography>
                <Typography sx={{ fontSize: 12 }} textAlign="left">{user.mail}</Typography>
              </Stack>
            </MenuItem>
            {/*<Divider />
                        <MenuItem key='Perfil' onClick={handleCloseUserMenu} component={Link} to='/capital-humano/profile'>
                            <FontAwesomeIcon icon={faUser} /><Typography sx={{ marginLeft: 2 }} textAlign="left">Perfil</Typography>
                        </MenuItem> */}
            <Divider />
            <MenuItem key='Cerrar sesión' onClick={logout} component={Link} to='/'>
              <LogoutIcon /><Typography sx={{ marginLeft: 2 }} textAlign="left">Cerrar sesión</Typography>
            </MenuItem>
          </Menu>

        {/*   <Menu
            id="menu-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose} key='perfil' component={Link} to='/user/user' >Perfil</MenuItem>
            <MenuItem onClick={logout}

            >Cerrar sesión</MenuItem>
          </Menu> */}
        </div>
      </Toolbar>
    </AppBar>

  )
}


export default Navigation;